module.exports = __webpack_public_path__ + "static/media/ic_proyectos_energy_pin_seleccionado.b24e6315.svg";